import { MessageBox } from 'element-ui';

export default function (router) {
    router.beforeEach((to, from, next) => {
        // Routes without middleware meta will be ignored and move on.
        if (! to.meta.middleware || ! to.meta.middleware.mustBeActiveMember) return next();

        const member = router.app.$store.getters['auth/userDetail']('profile');
        const isLapsedMembership = ['inactive', 'suspended'].indexOf(member.status) > -1 || member.membership.data.package === 'payg';

        if (! isLapsedMembership) {
            return next();
        } else {
            // Display a message box with option to upgrade membership.
            MessageBox.confirm('Please renew your membership to gain access to this course', 'Membership access restricted', {
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Renew membership'
            })
                .then(() => {
                    next('/dashboard/memberships');
                })
                .catch(() => {
                    next(from.path);
                });
        }
    })
}